var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-img',{staticClass:"mb-8",attrs:{"src":_vm.app.logo,"lazy-src":_vm.app.logo,"max-width":_vm.brand}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }